export default __webpack_public_path__ + "static/media/myworkspace.f77fe09c.svg";